import { TrendIndicator } from './TrendIndicator';
import './MetricCard.css';

type MetricCardProps = {
  label: string;
  value: string;
  change?: string;
  changeTone?: 'good' | 'warning' | 'attention' | 'neutral';
  metadata?: string;
  children?: React.ReactNode;
};

export function MetricCard({ label, value, change, changeTone = 'neutral', metadata, children }: MetricCardProps) {
  return (
    <article className="metric-card">
      <div className="metric-label">{label}</div>
      <div className="metric-value numeric">{value}</div>
      {change ? <TrendIndicator value={change} tone={changeTone} /> : null}
      {metadata ? <div className="metric-meta">{metadata}</div> : null}
      {children}
    </article>
  );
}
